module.exports = __webpack_public_path__ + "static/media/henrik_ehrnrooth.a634caf4.png";